import React, { useEffect, useRef, useState } from "react";
import { api, API } from "@/lib/api";
import { toast } from "sonner";
import { PenLine, Upload, Trash2, Loader2 } from "lucide-react";

// Sube/gestiona la firma escaneada personal (docente o coordinación) para planeaciones.
export default function SignatureUploader({ title = "Mi firma", help }) {
  const [url, setUrl] = useState(null);
  const [busy, setBusy] = useState(false);
  const fileRef = useRef(null);

  const load = () => api.get("/me/signature").then(({ data }) => setUrl(data.asset_url ? `${API}${data.asset_url}` : null)).catch(() => {});
  useEffect(() => { load(); }, []);

  const upload = async (f) => {
    if (!f) return;
    setBusy(true);
    try {
      const fd = new FormData(); fd.append("file", f);
      const { data } = await api.post("/me/signature", fd, { headers: { "Content-Type": "multipart/form-data" } });
      setUrl(`${API}${data.asset_url}?t=${Date.now()}`);
      toast.success("Firma guardada");
    } catch (e) { toast.error(e?.response?.data?.detail || "No se pudo subir la firma"); }
    finally { setBusy(false); if (fileRef.current) fileRef.current.value = ""; }
  };

  const remove = async () => {
    setBusy(true);
    try { await api.delete("/me/signature"); setUrl(null); toast.success("Firma eliminada"); }
    catch { toast.error("No se pudo eliminar"); }
    finally { setBusy(false); }
  };

  return (
    <div className="bg-white border border-nardo-200 rounded-2xl p-4 shadow-sm" data-testid="signature-uploader">
      <div className="flex items-center gap-2 mb-1"><PenLine className="w-4 h-4 text-navy-light" /><span className="font-semibold text-navy text-sm">{title}</span></div>
      {help && <p className="text-[11px] text-nardo-500 mb-3">{help}</p>}
      {url ? (
        <div className="flex items-center gap-3">
          <img src={url} alt="Firma" data-testid="signature-preview" className="h-16 w-auto max-w-[220px] object-contain bg-white border border-nardo-200 rounded-lg p-1" />
          <div className="flex flex-col gap-1.5">
            <label className="text-[11px] inline-flex items-center gap-1.5 text-navy border border-navy/30 hover:bg-navy hover:text-white rounded-lg px-3 py-1.5 cursor-pointer transition-colors" data-testid="signature-replace-label">
              {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Upload className="w-3.5 h-3.5" />} Cambiar
              <input ref={fileRef} type="file" accept="image/*" className="hidden" data-testid="signature-file" onChange={(e) => upload(e.target.files?.[0] || null)} />
            </label>
            <button onClick={remove} disabled={busy} data-testid="signature-delete" className="text-[11px] inline-flex items-center gap-1.5 text-red-600 border border-red-200 hover:bg-red-50 rounded-lg px-3 py-1.5"><Trash2 className="w-3.5 h-3.5" /> Quitar</button>
          </div>
        </div>
      ) : (
        <label className="text-xs inline-flex items-center gap-1.5 text-navy border border-navy/30 hover:bg-navy hover:text-white rounded-lg px-3 py-2 cursor-pointer transition-colors" data-testid="signature-upload-label">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Upload className="w-4 h-4" />} Subir firma (PNG con fondo transparente)
          <input ref={fileRef} type="file" accept="image/*" className="hidden" data-testid="signature-file" onChange={(e) => upload(e.target.files?.[0] || null)} />
        </label>
      )}
    </div>
  );
}
